import React, {useState} from "react";
import {getWeatherImage, getImage, sliceText} from "../../../utils/utils";
import {LinearProgressBar} from "../../progress-bar/LinearProgressBar";
import update from "../../../images/update.svg"
import startDateImg from "../../../images/project/start.svg"
import endDateImg from "../../../images/project/end.svg"
import styled, {css} from "styled-components";
import {getDateInFrench} from "../../../utils/dateUtils";
import {deleteOneProject, loadProject} from "../one-project/projectAction";
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import EditButton from "../../buttons/EditButton";
import DeleteButton from "../../buttons/DeleteButton";
import YesNoModal from "../../modal/YesNoModal";
import {loadProjects} from "../projects/projectsAction";
import accountSVG from "../../../images/account.svg";
import {loadOneAxis} from "../../axis/one-axis/oneAxisAction";
import {
    ARCHIVE_ROUTE,
    DASHBOARD_ABSOLUTE_ROUTE,
    STRATEGY_ABSOLUTE_ROUTE
} from "../../../routes/routesName";
import { DisplayForHead} from "../../../permissions/DisplayAccordingToRole";
import confidentialSVG from '../../../images/project/confidential.svg'
import WhereToEditProjectModal from "../../modal/WhereToEditProjectModal";
import UpdateProject from "../one-project/update/UpdateProject";



const SmallCardProject = ({
                              id = 0,
                              name,
                              pilot,
                              weather,
                              advancement = 0,
                              lastUpdate,
                              projectId,
                              endDate,
                              confidential,
                              startDate,
                              canBeEdited = false,
                              setIsOpenUpdateProject,
                              isOpenUpdateProject
                          }) => {


    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const currentUser = useSelector(state => state.currentUser)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const {id: axisId, sponsor} = useSelector(state => state.oneAxis)
    const isClickable = location.pathname === STRATEGY_ABSOLUTE_ROUTE || location.pathname === DASHBOARD_ABSOLUTE_ROUTE || !location.pathname.includes(ARCHIVE_ROUTE)
    const [isOpenYesNoModal, setIsOpenYesNoModal] = useState(false)

    const loadProjectHandler = async () => {
        if (location.pathname === STRATEGY_ABSOLUTE_ROUTE || location.pathname === DASHBOARD_ABSOLUTE_ROUTE) {
            navigate(`../${location.pathname}/${projectId}`)
        }
    }

    const updateProject = async () => {
            setIsOpenYesNoModal(true)
    }

    const deleteProject = async (project_id) => {
        await dispatch(deleteOneProject(project_id))
        if (location.pathname === STRATEGY_ABSOLUTE_ROUTE) {
            await dispatch(loadOneAxis(axisId))
        } else {
            await dispatch(loadProjects(currentUser.id))
            navigate.push(location.pathname)
        }
        setIsDeleteModalOpen(false)
    }
    const handleNavigation = async (name) => {
        if (name === 'edit-form') {
            await updateProject(projectId)
        }
        if (name === "guided-update") {
            navigate(`/maj-projet/${projectId}`)
        }
        setIsOpenYesNoModal(false)
    }

    const displayModal = () => {
        if (isDeleteModalOpen) {
            return (
                <YesNoModal
                    name={"ce projet (vous pouvez le retrouver dans les archives) ?"}
                    setOpenModal={setIsDeleteModalOpen}
                    id={id}
                    handleClickYesAction={deleteProject}
                />
            )
        }
        if (isOpenYesNoModal) {
            return (
                <UpdateProject projectId={id} setIsOpenUpdateProject={setIsOpenYesNoModal} />
            )
        }
    }

    return (
        <Card className="small-project-card"
              $mode={isClickable ? "clickable" : ""}
        >
            <Header>
                <div className={"flex-row ai-center w-100 pilot-section"}>
                    <img className={'pilot-picture'}
                         src={pilot !== null ? getImage(pilot.photo, accountSVG) : accountSVG}
                         alt="pilote"/>
                    <p> {pilot !== null ? pilot.firstName === "Deleted" ? "Utilisateur supprimé" : pilot.firstName : "pas de pilote"} {pilot !== null ? pilot.lastName === "User" ? "" : pilot.lastName : ""} </p>
                </div>
                {canBeEdited &&
                <ButtonsContainer className={"flex-row"}>
                    <DisplayForHead
                        hasException={currentUser.id === pilot.id || sponsor?.id === currentUser.id}
                        component={
                            <EditButton
                                customBehavior={updateProject}
                            />
                        }
                    />
                    <DisplayForHead
                        hasException={sponsor?.id === currentUser.id}
                        component={
                            <DeleteButton
                                setOpenDeleteModal={setIsDeleteModalOpen}
                            />
                        }
                    />
                </ButtonsContainer>
                }
            </Header>
            <Main onClick={isClickable ? loadProjectHandler : null}>
                <p className={'project-name'}> {sliceText(name, 70)} </p>

                <SecondSection>
                    <img src={getWeatherImage(weather)} alt="icone météo"/>
                    {LinearProgressBar(advancement)}
                </SecondSection>
                <LastSection>
                    <div>
                        <img src={startDateImg} alt="date de début"/>
                        <p className="fw-500">{startDate === null ? "Non défini" : getDateInFrench(startDate)} </p>
                    </div>
                    <div>
                        <img src={update} alt="mise à jour"/>
                        <p className="fw-500">{lastUpdate === null ? "Non défini" : getDateInFrench(lastUpdate)} </p>
                    </div>
                    <div>
                        <img src={endDateImg} alt="mise à jour"/>
                        <p className="fw-500">{endDate === null ? "Non défini" : getDateInFrench(endDate)} </p>
                    </div>
                    {confidential &&
                    <IMG src={confidentialSVG} alt={"ce projet est confidentiel"}/>
                    }
                </LastSection>
            </Main>
            {displayModal()}
        </Card>
    )
}


const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`
const Card = styled.div`
  background-color: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  border-radius: 12px;
  width: 100%;
  height: 18rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2rem;
  gap: 1.5rem;
  border: 1px solid rgb(221, 221, 221);

  p {
    width: 100%;
  }

  @media (min-width: 500px) {
    .project-name {
      width: 100%;
      font-weight: 600;
    }


    &:hover {
      ${(props) => {
        switch (props.$mode) {
          case "clickable":
            return css`
              background-color: var(--color-grey-03);
              cursor: pointer;
            `;
          default:
            return css``;
        }
      }}
    }
  }

`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  .pilot-picture {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  .pilot-section {
    display: flex;
    gap: 0.5rem;

    p {
      font-size: 12px;
    }
  }

  p {
    align-self: center;
    flex-grow: 1;
  }
`

const IMG = styled.img`
  width: 24px;
  height: 24px;
`

const SecondSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 1rem;
  justify-content: flex-start;

  .advancement-div {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    //TODO : redundance of code
    .progress-container {
      height: 10px;
      width: 170px;
      border-radius: 0.4rem;
      background: rgba(204, 204, 204, 0.5);
      -webkit-tap-highlight-color: transparent;
    }

    p {
      padding-left: 1em;
      width: unset;
      font-size: 70%;
    }
  }

  img {
    width: 40px;
    height: 40px;
  }
`
const LastSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 1rem;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  p {
    font-size: 10px;
    padding-left: 0.5em;
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  grid-column-start: 3;
  grid-column-end: 3;


  button {
    width: 32px;
    height: 32px;
  }
`

export default SmallCardProject;